import './style.css';
import { useState, useEffect, useContext, useRef } from "react";
import Context from "../../storage/context";

// function ZoomOverlay({ src, onClose }) {
//     useEffect(() => {
//         const esc = e => e.key === "Escape" && onClose();
//         window.addEventListener("keydown", esc);
//         return () => window.removeEventListener("keydown", esc);
//     }, [onClose]);
//     return (
//         <div className="zoom-overlay" onClick={onClose}>
//             <img src={`data:image/jpeg;base64,${src}`} alt="zoom" onClick={e => e.stopPropagation()} />
//         </div>
//     );
// }

function Gallery({ images }) {
    let ctx = useContext(Context);
    const [idx, setIdx] = useState(0);
    const [loadedImages, setLoadedImages] = useState({});
    const [direction, setDirection] = useState(null);
    const touchStartX = useRef(null);

    useEffect(() => {
        images.forEach((src, i) => {
            const img = new Image();
            img.src = `${ctx.api_url}${src}`;
            img.onload = () => {
                setLoadedImages(prev => ({ ...prev, [i]: img.src }));
            };
        });
    }, [images]);

    const currentSrc = loadedImages[idx] || `${ctx.api_url}${images[idx]}`;

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
        if (touchStartX.current === null) return;
        const diff = touchStartX.current - e.changedTouches[0].clientX;
        if (diff > 50) {
            setDirection("left");
            setIdx(i => Math.min(i + 1, images.length - 1));
        } else if (diff < -50) {
            setDirection("right");
            setIdx(i => Math.max(i - 1, 0));
        }
        touchStartX.current = null;
    };

    return (
        <>
            <div
                className="gallery"
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
            >
                <img
                    key={idx}
                    src={currentSrc}
                    alt=""
                    className={`gallery-main slide-${direction}`}
                    loading="lazy"
                />
                {images.length > 1 && (
                    <>
                        <button
                            className="gallery-nav prev"
                            onClick={() => { setDirection("right"); setIdx(i => Math.max(i - 1, 0)); }}
                            disabled={idx === 0}
                        >‹</button>
                        <button
                            className="gallery-nav next"
                            onClick={() => { setDirection("left"); setIdx(i => Math.min(i + 1, images.length - 1)); }}
                            disabled={idx === images.length - 1}
                        >›</button>
                    </>
                )}
                <div className="gallery-counter">{idx + 1} מתוך {images.length}</div>
            </div>

            {images.length > 1 && (
                <div className="gallery-dots">
                    {images.map((_, i) => (
                        <div key={i} className={`gdot${i === idx ? " on" : ""}`} onClick={() => setIdx(i)} />
                    ))}
                </div>
            )}
        </>
    );
}

/* ── SVG ICONS ── */
const Icons = {
    plate: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="7" width="20" height="10" rx="2" /><path d="M6 12h.01M18 12h.01" /></svg>,
    make: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M12 8v4l3 3" /></svg>,
    model: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 17H5a2 2 0 01-2-2V9a2 2 0 012-2h2l2-2h6l2 2h2a2 2 0 012 2v6a2 2 0 01-2 2z" /></svg>,
    year: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>,
    km: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10" /><path d="M12 8v4l2 2" /><path d="M2 12h2M20 12h2M12 2v2M12 20v2" /></svg>,
    test: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11l3 3L22 4" /><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" /></svg>,
    cc: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 2a10 10 0 110 20 10 10 0 010-20z" /><path d="M12 6v6l4 2" /></svg>,
    hand: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M18 11V6a2 2 0 00-2-2v0a2 2 0 00-2 2v0" /><path d="M14 10V4a2 2 0 00-2-2v0a2 2 0 00-2 2v2" /><path d="M10 10.5V6a2 2 0 00-2-2v0a2 2 0 00-2 2v8" /><path d="M18 11a2 2 0 114 0v3a8 8 0 01-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 012.83-2.82L7 15" /></svg>,
    gear: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3" /><path d="M19.07 4.93l-1.41 1.41M4.93 4.93l1.41 1.41M19.07 19.07l-1.41-1.41M4.93 19.07l1.41-1.41M12 2v2M12 20v2M2 12h2M20 12h2" /></svg>,
    body: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 17H3a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v9a2 2 0 01-2 2h-2" /><circle cx="7.5" cy="17.5" r="2.5" /><circle cx="17.5" cy="17.5" r="2.5" /></svg>,
    color: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="13.5" cy="6.5" r=".5" fill="currentColor" /><circle cx="17.5" cy="10.5" r=".5" fill="currentColor" /><circle cx="8.5" cy="7.5" r=".5" fill="currentColor" /><circle cx="6.5" cy="12.5" r=".5" fill="currentColor" /><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 011.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z" /></svg>,
    owner: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>,
    desc: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="17" y1="10" x2="3" y2="10" /><line x1="21" y1="6" x2="3" y2="6" /><line x1="21" y1="14" x2="3" y2="14" /><line x1="17" y1="18" x2="3" y2="18" /></svg>,
};

function DetailRow({ label, value, full, icon }) {
    if (!value && value !== 0) return null;
    return (
        <div className={`detail-row${full ? " full" : ""}`}>
            <span className="detail-label">
                {icon && <span className="detail-icon">{icon}</span>}
                {label}
            </span>
            <span className="detail-value">{value}</span>
        </div>
    );
}

function CarDetails({ car, open, onClose }) {
    // close on Escape
    useEffect(() => {
        const fn = e => e.key === "Escape" && onClose();
        if (open) window.addEventListener("keydown", fn);
        return () => window.removeEventListener("keydown", fn);
    }, [open, onClose]);

    // prevent body scroll when open
    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [open]);

    if (!car) return null;
    let images = []
    if (car.p_1 !== "" && car.p_1 !== null) {
        images.push(car.p_1)
    }
    if (car.p_2 !== "" && car.p_2 !== null) {
        images.push(car.p_2)
    }
    if (car.p_3 !== "" && car.p_3 !== null) {
        images.push(car.p_3)
    }
    if (car.p_4 !== "" && car.p_4 !== null) {
        images.push(car.p_4)
    }
    if (car.p_5 !== "" && car.p_5 !== null) {
        images.push(car.p_5)
    }
    if (car.p_6 !== "" && car.p_6 !== null) {
        images.push(car.p_6)
    }

    function formatNumber(numStr) {
        return Number(numStr).toLocaleString("en-US");
    }

    const handleShare = (e) => {
        e.stopPropagation();
        const url = `${window.location.origin}/cars/${car.car_id}`;

        if (navigator.share) {

            navigator.share({
                title: `${car.car_make} ${car.car_full_type}`,
                text: `${car.car_make} ${car.car_full_type} ${car.year} - ${formatNumber(car.price)} ₪`,
                url
            });
        } else {
            navigator.clipboard.writeText(url);
        }
    };


    return (
        <div className={`overlay${open ? " open" : ""}`} onClick={onClose}>
            <div className="modal" onClick={e => e.stopPropagation()}>

                {/* close button */}
                <button className="modal-close" onClick={onClose} aria-label="סגור">✕</button>

                {/* gallery */}
                <Gallery images={images} />

                {/* body */}
                <div className="modal-body">
                    <h2 className="modal-name">{car.make} {car.model}</h2>
                    {car.tag && <div className="modal-tag">{car.tag}</div>}

                    <div className="details-grid">
                        {/* <DetailRow label="מספר רכב" value={car.plateNumber} icon={Icons.plate} /> */}
                        <DetailRow label="יצרן" value={car.car_make} icon={Icons.make} />
                        <DetailRow label="דגם" value={car.car_full_type} icon={Icons.model} />
                        <DetailRow label="שנת ייצור" value={car.year} icon={Icons.year} />
                        <DetailRow label="קילומטרים" value={car.km ? `${formatNumber(car.km)} ק"מ` : null} icon={Icons.km} />
                        <DetailRow label="טסט עד" value={car.testUntil} icon={Icons.test} />
                        <DetailRow label='סמ"ק' value={car.engine ? `${formatNumber(car.engine)} סמ"ק` : null} icon={Icons.cc} />
                        <DetailRow label="יד" value={car.hand} icon={Icons.hand} />
                        <DetailRow label="גיר" value={car.gear} icon={Icons.gear} />
                        <DetailRow label="סוג מרכב" value={car.car_type} icon={Icons.body} />
                        <DetailRow label="צבע" value={car.color} icon={Icons.color} />
                        <DetailRow label="בעלים" value={car.owner} icon={Icons.owner} />
                    </div>

                    {car.more_details && (
                        <div className="desc-box">
                            <div className="desc-label" style={{ display: "flex", alignItems: "center", gap: 7 }}>
                                <span style={{ display: "flex", alignItems: "center", color: "var(--gold)", opacity: .8 }}>{Icons.desc}</span>
                                תיאור
                            </div>
                            <div className="desc-text">{car.more_details}</div>
                        </div>
                    )}

                    {car.tiktok_url && (
                        <a className="tiktok-btn" href={car.tiktok_url} target="_blank" rel="noreferrer">
                            <span className="tiktok-btn__ico">🎵</span>
                            <div>
                                <div className="tiktok-btn__title">צפה בסרטון הרכב</div>
                                <div className="tiktok-btn__sub">נפתח ב-TikTok</div>
                            </div>
                            <span className="tiktok-btn__arrow">←</span>
                        </a>
                    )}

                    <div className="tiktok-btn" style={{ cursor: "pointer" }} onClick={handleShare}>
                        <span className="tiktok-btn__ico">🔗</span>
                        <div>
                            <div className="tiktok-btn__title">שתף</div>
                        </div>
                        <span className="tiktok-btn__arrow">←</span>
                    </div>

                    {/* price */}
                    <div className="price-section">
                        <div>
                            <div className="price-label">מחיר</div>
                            <div className="price-value">
                                {formatNumber(car.price)}
                                <span className="price-sym">₪</span>
                            </div>
                            <div className="price-vat">כולל מע"מ</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CarDetails;